import { ServiceAssociationDiscountType } from '@/_api/models/serviceAssociation'

export interface ServiceAssociationOpportunity {
  association: any
  source: any
  target: any
  targetPrice: number
}

function serviceId (service: any): number | null {
  return service?.idService ?? service?.id ?? null
}

export function serviceAssociationSaving (association: any, target: any): number {
  const price = Number(target?.price || association?.target?.price || 0)
  const discount = Number(association?.discountAmount || 0)

  if (association?.discountType === ServiceAssociationDiscountType.Percentage) {
    return Math.min(price, price * discount / 100)
  }

  return Math.min(price, discount)
}

export function bestAssociationForTarget (
  entries: any[],
  target: any,
  targetEntry: any = null,
  targetPrice = Number(target?.price || 0),
): ServiceAssociationOpportunity | null {
  const targetId = serviceId(target)
  let best: ServiceAssociationOpportunity | null = null

  if (targetId == null) return null

  for (const source of entries) {
    if (!source?.service || source === targetEntry || source.association) continue

    for (const association of source.service.sourceAssociations || []) {
      if (association.target_type !== 'service' || association.target_id !== targetId) continue

      const pricedTarget = { ...target, price: targetPrice }
      const saving = serviceAssociationSaving(association, pricedTarget)
      if (saving < 0) continue

      const opportunity = { association, source, target: targetEntry, targetPrice }
      if (!best || saving > serviceAssociationSaving(best.association, pricedTarget)) {
        best = opportunity
      }
    }
  }

  return best
}

export function regularTargetsForSource (entries: any[], source: any): any[] {
  if (!source?.service || source.association) return []

  const targetIds = new Set(
    (source.service.sourceAssociations || [])
      .filter((association: any) => association.target_type === 'service')
      .map((association: any) => association.target_id),
  )

  return entries.filter((entry: any) => (
    entry !== source
    && entry?.service
    && !entry.association
    && targetIds.has(serviceId(entry.service))
  ))
}
